import clsx from 'clsx';
import { useState } from 'react';

import { Typography } from '../Typography';

export type MenuItemProps = {
	icon?: {
		iconDefault: string;
		iconActive: string;
		iconHover: string;
	};
	isActive?: boolean;
	isExpanded: boolean;
	label: string;
	onClick?: () => void;
	testId?: string;
};

export const MenuItem = (props: MenuItemProps) => {
	const {
		icon = { iconDefault: '', iconActive: '', iconHover: '' },
		isActive = false,
		isExpanded = false,
		label,
		onClick,
		testId,
	} = props;
	const [isHover, setIsHover] = useState(false);

	const onMouseEnter = () => {
		setIsHover(true);
	};

	const onMouseLeave = () => {
		setIsHover(false);
	};

	const renderMenuIcon = () => {
		if (!icon.iconDefault && !icon.iconActive && !icon.iconHover) return null;

		const iconSrc = isHover ? icon.iconHover : isActive ? icon.iconActive : icon.iconDefault;

		return <img className='w-6 min-w-6' alt={label} src={iconSrc} />;
	};

	return (
		// eslint-disable-next-line jsx-a11y/click-events-have-key-events, jsx-a11y/no-static-element-interactions
		<div
			className='flex flex-row items-center hover:bg-highlight w-full max-h-12 rounded-md p-3'
			onMouseEnter={onMouseEnter}
			onMouseLeave={onMouseLeave}
			onClick={onClick}
			data-test-id={`${testId}-menu-item`}
		>
			{renderMenuIcon()}
			<Typography
				className={clsx(
					'pt-1 ml-2',
					'transition-visibility ease-linear delay-300 duration-300',
					isExpanded
						? 'w-auto opacity-100 visible '
						: 'w-0 overflow-x-hidden opacity-0 invisible'
				)}
			>
				{label}
			</Typography>
		</div>
	);
};
